

import RequestAbstract from "../abstract";

export default class WalletAccounts extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallet/accounts";
    }
}

